import { render, staticRenderFns } from "./DxpInboxItemTargetObjectMatchedContractUpdateOverlay.vue?vue&type=template&id=7334b464&scoped=true"
import script from "./DxpInboxItemTargetObjectMatchedContractUpdateOverlay.vue?vue&type=script&lang=js"
export * from "./DxpInboxItemTargetObjectMatchedContractUpdateOverlay.vue?vue&type=script&lang=js"
import style0 from "./DxpInboxItemTargetObjectMatchedContractUpdateOverlay.vue?vue&type=style&index=0&id=7334b464&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7334b464",
  null
  
)

export default component.exports